import Vue from 'vue'
import VueI18n from 'vue-i18n'
// import Cookies from 'js-cookie'
// import scLocale from './sc'
// import tcLocale from './tc'
import enLocale from './en'
// import ruLocale from './ru'
import jpLocale from './jp'
// import esLocale from './es'
// import thLocale from './th'
// import hiLocale from './hi'
// import ptLocale from './pt'
// import trLocale from './tr'
// import krLocale from './kr'

Vue.use(VueI18n)

const messages = {
  // sc: {
  //   ...scLocale
  // },
  // tc: {
  //   ...tcLocale
  // },
  en: {
    ...enLocale
  },
  // ru: {
  //   ...ruLocale
  // },
  jp: {
    ...jpLocale
  }
  // es: {
  //   ...esLocale
  // },
  // th: {
  //   ...thLocale
  // },
  // hi: {
  //   ...hiLocale
  // },
  // pt: {
  //   ...ptLocale
  // }
  // tr: {
  //   ...trLocale
  // },
  // kr: {
  //   ...krLocale
  // }
}

let LANGUAGE = 'en'
if (window.location.host.indexOf('kkpoker.jp') > -1 || window.location.host.indexOf('jp.kkpoker.net') > -1) {
  LANGUAGE = 'jp'
}

const i18n = new VueI18n({
  // set locale
  // options: en | zh | es
  locale: LANGUAGE || 'en',
  // set locale messages
  messages
})

export default i18n
